import { z } from "zod"

// Step 1: Destination Details
export const destinationSchema = z.object({
  purposeOfTravel: z.string().min(1, "Purpose of travel is required"),
  destination: z.string().min(1, "Destination is required"),
      // .object({
    //   value: z.string(),
    //   label: z.string(),
    // }).refine(data => data.value.trim() !== "", {
    //   message: "Destination is required",
    // }),
    //   dateRange: z
    // .object({
    //   start_date: z.string().min(1, "From date is required"),
    //   end_date: z.string().min(1, "To date is required"),
    // })
    // .refine((data) => {
    //   const startDate = new Date(data.start_date);
    //   const endDate = new Date(data.end_date);
    //   return startDate <= endDate;
    // }, {
    //   message: "End date cannot be earlier than start date",
    //   path: ["end_date"],
    // }),
  dateRange: z.object({
    start_date: z.string().optional(),
    end_date: z.string().optional(),
  }).refine((data) => {
    if (!data.start_date || !data.end_date) return true;
    const startDate = new Date(data.start_date);
    const endDate = new Date(data.end_date);
    return startDate <= endDate;
  }, {
    message: "End date cannot be earlier than start date",
    path: ["end_date"],
  }),
});


// Product Schema
export const currencySchema = z.object({
  currency: z.object({
    value: z.string(),
    label: z.string(),
  }),
  amount: z.number().positive("Amount must be positive"),
  rate: z.number().optional(),
})

export const productSchema = z.object({
  productType: z.object({
    value: z.string(),
    label: z.string(),
    type: z.string().optional(),
  }),
  cardType: z
    .object({
      value: z.string(),
      label: z.string(),
    })
    .optional(),
  currencies: z.array(currencySchema).min(1, "At least one currency is required"),
  local_id: z.string()
})

// Step 2: Customer Details
export const customerSchema = z.object({
  customerId: z.string().optional(),
  mobileNumber: z.string().min(10, "Mobile number must be at least 10 digits"),
  fullName: z.string().min(1, "Full name is required"),
  email: z.string().email("Invalid email address").optional().or(z.literal("")),
  pan: z.string().optional(),
  products: z.array(productSchema).min(1, "At least one product is required"),
})

// Step 3: Delivery Details
export const addressSchema = z.object({
  address1: z.string().min(1, "Address line 1 is required"),
  address2: z.string().optional(),
  landmark: z.string().optional(),
  country: z.object({
    value: z.string(),
    label: z.string(),
  }),
  state: z.object({
    value: z.string(),
    label: z.string(),
  }),
  city: z.string().min(1, "City is required"),
  pincode: z.string().min(1, "Pincode is required"),
})

export const deliverySchema = z.object({
  deliveryMode: z.object({
    value: z.string(),
    label: z.string(),
  }).refine(data => data.value.trim() !== "", {
    message: "Delivery mode is required",
  }),
  deliveryId: z.string().min(1, "Delivery ID is required"),
  products: z
    .array(
      z.object({
        value: z.string(),
        label: z.string(),
      }),
    )
    .min(1, "At least one product is required"),
  customers:
      z.object({
        value: z.string(),
        label: z.string(),
      }).refine(data => data.value.trim() !== "", {
        message: "Customer ID is required",
      }),
  deliveryType: z.enum(["self", "courier", "pickup"]).optional(),
  locationInfo: z.string().optional(),
  addresses: z.array(addressSchema).min(1, "At least one address is required"),
  local_id: z.array(z.string()).optional(),
  address_id:z.string()
})

// Complete Form Schema
export const travelBookingSchema = z.object({
  destination: destinationSchema,
  customers: z.array(customerSchema).min(1, "At least one customer is required"),
  deliveries: z.preprocess((val) => val ?? [], z.array(deliverySchema).optional()),
  order_type: z.enum(["buy", 'sell']).optional(),
})

export type DestinationFormValues = z.infer<typeof destinationSchema>
export type CustomerFormValues = z.infer<typeof customerSchema>
export type ProductFormValues = z.infer<typeof productSchema>
export type DeliveryFormValues = z.infer<typeof deliverySchema>
export type TravelBookingFormValues = z.infer<typeof travelBookingSchema>
